export default {
  booking: {
    title: 'Finaliser ma réservation',
    titleIndividual: 'Finalisez votre réservation',
    titleMinarm: 'Finaliser ma réservation',
    infoStep: {
      content: '<b>Bonne nouvelle !</b> Votre déménageur a confirmé sa disponibilité pour la prise en charge de votre déménagement.<br/>Veuillez finaliser la réservation en validant le récapitulatif ci-dessous.',
    },
    warningMinarm: 'Suite à l\'estimation du plafond financier calculée en fonction de vos droits réglementaires, vous êtes susceptible d\'avoir un reste à votre charge par rapport à l\'indemnisation de l\'administration en choisissant cette proposition. Par conséquent, vous pouvez décider de :<ul><li>prendre en charge le dépassement de plafond (soit {priceDiff}) ; veuillez rentrer ci-dessous vos références de carte bancaire.</li><li>contacter votre conseiller Nextories pour modifier votre demande et ajuster le montant de la prestation dans la limite de votre plafond financier.</li></ul>',
    warningCommissionnaire: 'Suite à l\'estimation du montant d\'indemnisation pris en charge par votre entreprise, vous êtes susceptible d\'avoir un reste à votre charge en choisissant cette proposition. Par conséquent, vous pouvez décider de :<ul><li>prendre en charge la différence(soit {priceDiff}) ; veuillez rentrer ci-dessous vos références de carte bancaire.</li><li>contacter votre conseiller Nextories pour modifier votre demande et ajuster le montant de la prestation dans la limite de la prise en charge financière de votre entreprise.</li></ul>',
    validateLabel: '<b>Voulez vous valider le choix de cette proposition ?</b><br>Une fois votre choix validé, nous vous mettrons en relation avec {moverName} et vous pourrez finaliser la réservation de votre déménagement et signer votre devis auprès du déménageur.',
    infoDate: 'Date envisagée de chargement : le {loadDate}.',
    dateSpecific: 'La date exacte de déménagement sera à préciser avec votre déménageur.',
    remainingCost: 'Reste à votre charge',
    services: 'Services inclus',
    options: 'Options choisies',
    optionsSelected: 'Vous n\'avez choisi aucune des options proposées.',
    descriptionArrhesIndividual: '<i>Dans le cadre de votre déménagement, les arrhes représentent la somme que vous réglez pour confirmer votre réservation. Cette somme sera déduite du solde total de votre déménagement.</i>',
    arrhesAmountIndividual: 'Dans le cadre d’un déménagement, les arrhes représentent une sommes que vous avancez pour bloquer votre réservation. Cette somme sera déduite du solde total de votre déménagement.',
    footerText: 'Suite à votre validation, la société {name} vous contactera afin de finaliser l\'organisation de votre déménagement. Vous pourrez ainsi valider le planning de votre déménagement et procéder à la réservation de la prestation.',
    book: 'Réserver',
    bookIndividual: 'Réserver',
    bookIndividualWithArrhes: 'Continuer',
    cardContent: '<p>Veuillez vérifier que l\'ensemble des informations correspondent, puis cliquez sur le bouton &laquo; Valider &raquo; pour confirmer et passer à la signature de votre devis.</p>',
    cardContentIndividual: '<p>Vous êtes sur le point de confirmer cette offre. Vérifiez l\'ensemble des informations puis cliquez sur &laquo; Réserver &raquo;.</p>',
    cardContentIndividualWithArrhes: '<p>Vous êtes sur le point de confirmer cette offre. Vérifiez l\'ensemble des informations puis cliquez sur &laquo; Continuer &raquo;.</p>',
    guaranteedPrice: 'Tarif garanti',
    seePdf: 'Voir le PDF',
  },
  button: {
    back: 'Retour',
    update: 'Modifier',
    valid: 'Valider',
    prebook: 'Pré-réserver',
  },
  choose: {
    choose: 'Valider',
    services: 'Services inclus',
    options: 'Options choisies',
    optionsSelected: 'Vous n\'avez choisi aucune des options proposées.',
    footerText: 'Suite à votre validation, la société {name} vous contactera afin de finaliser l\'organisation de votre déménagement. Vous pourrez ainsi valider le planning de votre déménagement et procéder à la réservation de la prestation.',
  },
  chosenOptions: {
    title: '',
    subtitle: 'Options choisies',
  },
  formule: {
    title: 'FORMULE « {formule} »',
    subtitle: 'Ce que font les déménageurs',
  },
  leftToDo: {
    subtitle: 'Ce qui reste à votre charge',
  },
  move: 'Récapitulatif de votre déménagement',
  mover: 'Mon déménageur',
  price: {
    title: 'Montant tout inclus de la prestation',
    content: 'En choisissant cette offre, vous bloquez les dates et les conditions tarifaires auprès du déménageur <b>pendant {nbDaysBookingLimit}</b>.',
  },
  boxes: {
    paiement: '<b>Pas de paiement</b><br>avant la signature du contrat',
    cancel: '<b>Annulation gratuite</b><br>jusqu\'à la signature de votre contrat',
    insurance: '<b>Garantie zéro surprise</b><br>Nos devis sont fermes et définitifs',
  },
  nota: '<span><b>À noter : </b>{arrhesPercent} %, à la réservation et {arrhesMovePercent} % {date} avant le déménagement.</span>',
  preBooking: {
    title: 'Pré-réserver une offre',
    titleIndividual: 'Le détail de l’offre {mover}',
    warningMinarm: 'Suite à l\'estimation du plafond financier calculée en fonction de vos droits réglementaires, vous êtes susceptible d\'avoir un reste à votre charge par rapport à l\'indemnisation de l\'administration en choisissant cette proposition. Par conséquent, vous pouvez décider de :<ul><li>prendre en charge le dépassement de plafond ;</li><li>contacter votre conseiller Nextories pour modifier votre demande et ajuster le montant de la prestation dans la limite de votre plafond financier.</li></ul>',
    warningCommissionnaire: 'Suite à l\'estimation du montant d\'indemnisation pris en charge par votre entreprise, vous êtes susceptible d\'avoir un reste à votre charge en choisissant cette proposition. Par conséquent, vous pouvez décider de :<ul><li>prendre en charge la différence;</li><li>contacter votre conseiller Nextories pour modifier votre demande et ajuster le montant de la prestation dans la limite de la prise en charge financière de votre entreprise.</li></ul>',
    infoStep: {
      content: '<b>ÉTAPE {currentStep}/{totalSteps}</b><br>Découvrez toutes les informations spécifiques de votre déménageur et <b>validez la date de chargement</b> ainsi que les prestations souhaitées pour votre déménagement.',
    },
    commitmentInformation: 'En pré-réservant cette offre, nous bloquons les dates et les conditions tarifaires auprès du déménageur <b>pendant {nbDaysBookingLimit}.</b><br><br>Une fois votre offre pré-réservée, nous la transmettrons à votre employeur pour validation, et vous alerterons par email dès que la prise en charge sera validée.',
    commitmentInformationMinarm: 'En pré-réservant cette offre, nous bloquons les dates et les conditions tarifaires auprès du déménageur <b>pendant {nbDaysBookingLimit}</b>.<br><br>Une fois votre offre pré-réservée, vous aurez la possibilité de télécharger le devis correspondant pour pouvoir le transmettre @:base.minarm_organism_au et constituer votre dossier de déménagement en ligne.',
    commitmentInformationIndividual: 'En choisissant cette offre, vous bloquez les dates et les conditions tarifaires auprès du déménageur <b>pendant {nbDaysBookingLimit}</b>.<ul><li>Pas de paiement avant la signature du devis</li><li>Annulation gratuite (jusqu\'à la signature du devis)</li></ul>',
    remainingCost: 'Reste à votre charge',
    services: 'Services inclus',
    options: 'Options choisies',
    optionsSelected: 'Vous n\'avez choisi aucune des options proposées.',
    dateTitle: 'Date du chargement',
    dateSubTitle: 'Le déménageur propose un chargement {loadingDate}.',
    dateNotSuitable: 'Je souhaiterais choisir une {otherDate}date',
    footerText: 'NB: Sans retour de votre part au bout de ces {nbDaysBookingLimit}, la pré-réservation pourra être annulée. La validité de l\'offre du déménageur ne sera alors plus garantie.',
    footerTextCommissionnaire: 'NB: Sans retour de votre employeur au bout de ces {nbDaysBookingLimit}, la pré-réservation pourra être annulée. La validité de l\'offre du déménageur ne sera alors plus garantie. N\'hésitez pas à relancer votre département RH pour que la validation puisse être faite dans les temps.',
    preReservation: 'Pré-réserver',
    preReservationIndividual: 'Choisir',
    cguLink: `${import.meta.env.VITE_APP_CDN}docs/cgv_pfmd.pdf`,
    cguAcceptation: 'J\'accepte les ',
    cguLabel: 'Conditions générales d\'utilisation du service PFMD',
    cguError: 'Veuillez accepter les conditions générales d\'utilisation pour continuer',
  },
  services: {
    title: 'Prestations spécifiques',
    subtitle: 'Les services en plus inclus dans votre devis',
  },
  options: {
    title: 'Vos options',
    subtitle: 'Vos options',
  },
  title: 'Choisir {mover}',
  loadingText: 'Validation en cours...',
  total: 'TOTAL : <b>{price}</b>',
  partnerDiscount: {
    banner: 'Réduction partenaire -{rate}%',
    saving: 'Vous économisez {price}',
    savingLabel: 'Vous économisez',
  },
  insurance: {
    title: 'Garantie incluse',
    type: {
      CLASSIQUE: 'Assurance contractuelle',
      COMPLEMENTAIRE: 'Assurance dommages',
    },
  },
};
